import url from "url";
import Router from "next/router";
import QS from "querystring";
import * as withConditions from "@insightfulscience/smart-react/hocs/WithConditions";
import routes from "./routes";
import { splitParams } from "./split-params";
import { buildQuery } from "./utils-smart/url-refs";

const getReturnUrl = (pathname, queryParams, path = null) =>
	// prettier-ignore
	queryParams.returnUrl ? queryParams.returnUrl :
	pathname === routes.exchange ? routes.myAccount	:
	path; /* otherwise */

export const cleanReturnUrl = path => {
	const { pathname, query } = url.parse(path);
	return getReturnUrl(pathname, QS.parse(query), path);
};

const decode = path => path && decodeURIComponent(path);
const isUtmParam = ([param]) => /^utm_/i.test(param);

const isAbsoluteURL = urlString => /^([a-z]+:)?\/\//i.test(urlString);

export const toReturnUrl = fallback => ({ query }) =>
	(!isAbsoluteURL(query.returnUrl) && decode(query.returnUrl)) || //
	fallback ||
	routes.myAccount;

const getQuery = () => QS.parse(global.location.search.replace(/^\?/, ""));

export const followToReturlUrl = ({ fallback }) => {
	const resolveReturnUrl = toReturnUrl(fallback);
	return () => Router.replace(resolveReturnUrl({ query: getQuery() }));
};

export const toLoginUrl = ({ returnUrl, ...params }) =>
	`${routes.auth.login}${buildQuery({ returnUrl: encodeURIComponent(returnUrl), ...params })}`;

export const toLogin = ({ asPath }) => {
	const { pathname, query } = url.parse(asPath);
	const [, restParams] = splitParams(QS.parse(query), isUtmParam);

	return toLoginUrl({
		returnUrl: getReturnUrl(pathname, restParams) ?? `${pathname}${buildQuery(restParams)}`,
	});
};

const search = searchString => searchString && `?${searchString}`;

export const ref = (path, query) => `${path}${search(QS.stringify(query))}`;

withConditions.mapServerSideRedirectUrl((pathOrUrl, { query }) => {
	const parsedUrl = url.parse(pathOrUrl);

	if (parsedUrl.hostname) return pathOrUrl;

	return url.format({
		...parsedUrl,
		search: null,
		query: {
			...QS.parse(parsedUrl.query),
			...splitParams(query, isUtmParam)[0],
		},
	});
});

export const subsRef = (path, subscriptionID) => `${path}?subscriptionId=${subscriptionID}`;

export const toSubscriptionDashboard = ({ subscriptionID }) =>
	subsRef(routes.subscription.dashboard, subscriptionID);

export const toCompleteProfilePage = trialId =>
	Router.push({ pathname: routes.completeProfile, query: { trialId } });

export const toFreeTrialPage = () => `${routes.freeTrial}`;
